<div class="{{verticalAlign? cssClasses : cssClasses + ' align-items-center ms-0'}}">
  <label *ngIf="title" class="{{verticalAlign?'': 'me-2'}}">{{title|translate}}</label>
  <div>
    <div ngbDropdown container="body">
      <button
        class="margin-bottom-1 btn btn-{{dropdownStyle}} {{width}} custom-form-component {{hasError?'invisible-error': ''}}"
        [disabled]="disabled"
        id="dropdownMenuButton"
        ngbDropdownToggle
        rippleEffect
        type="button"
        #myInput
        [tabIndex]="tabAccess? 0: -1">
        {{selectedItemInternal | translate}}
      </button>
      <div aria-labelledby="dropdownMenuButton" ngbDropdownMenu>
        <a (click)="setSelectedOption(item)" *ngFor="let item of items" href="javascript:void(0)"
           ngbDropdownItem>{{displayField ? (item[displayField]|translate) : (item |translate)}}
        </a>
      </div>
    </div>
  </div>
</div>
